import React from "react";
import { EvtSelect } from "components/select";
import { getDirectusField } from "directus/src/operations";
import { useFetch } from "hooks/src/useFetch";

const IndustryInput = ({
  value,
  onChange,
  className,
  placeholder,
  ...props
}) => {
  const { data, isLoading, error } = useFetch({
    queryKey: ["industries", "type"],
    queryFn: async () => {
      const response = await getDirectusField("industries", "type");

      const data = response.meta.options.choices.map((industry) => {
        return { name: industry.text, id: industry.value };
      });
      return data;
    },
  });

  return (
    <EvtSelect
      value={value}
      onChange={onChange}
      className={className}
      data={data}
      isLoading={isLoading}
      placeholder={placeholder}
      {...props}
    />
  );
};

export default IndustryInput;
